// Клетката с името на категорията в „По категории".
//
// Тя е ЕДИНСТВЕНАТА в реда, която не отваря разбивката по дни: името е линк
// към „По артикули" за тази категория, а всичко останало в реда си остава
// клик по реда. Затова бутонът спира разпространението на събитието — иначе
// същият клик би пуснал и двете действия.
//
// Обвивката повтаря тази на `DataCell` за `kind: "text"`, за да реже дългите
// имена еднакво с другите колони.

import { useTranslation } from "react-i18next";

import type { CategoryRow } from "./categoriesMath";

type Props = {
  row: CategoryRow;
  onOpenItems: (row: CategoryRow) => void;
};

export const CategoryNameCell = ({ row, onOpenItems }: Props) => {
  const { t } = useTranslation();

  // Артикулите без категория са в обща кофа без id — нея няма къде да я
  // отворим, затова редът ѝ е обикновен текст, а не мъртъв линк.
  // Продажбите от обедно меню в категорията — отделен ред с етикет
  const lunchTag = row.isLunch ? (
    <span className="shrink-0 rounded-md bg-brand-tint px-1.5 py-[2px] text-[10.5px] font-bold leading-[normal] text-brand-deep-ink">
      {t("reportsPage.lunchTag")}
    </span>
  ) : null;

  if (row.categoryId === null) {
    return (
      <span className="flex min-w-0 items-center gap-1.5">
        <span className="truncate text-[13px] font-medium text-ink">
          {row.categoryName}
        </span>
        {lunchTag}
      </span>
    );
  }

  return (
    <span className="flex min-w-0 items-center gap-1.5">
      <button
        type="button"
        onClick={(event) => {
          // Без това същият клик минава и през реда и отваря разбивката по
          // дни върху артикулите.
          event.stopPropagation();
          onOpenItems(row);
        }}
        title={t("reportsPage.categoriesOpenItems", { name: row.categoryName })}
        className="min-w-0 truncate text-left text-[13px] font-bold text-brand-deep-ink hover:underline focus-visible:underline"
      >
        {row.categoryName}
      </button>
      {lunchTag}
    </span>
  );
};
